// Client-side mirror of the backend RBAC permission map (UX gating only; backend enforces).
export const ROLES = ["superadmin", "admin", "redaktör", "handläggare", "läsare"];

export const ROLE_LABELS = {
  superadmin: "Super Admin",
  admin: "Admin",
  redaktör: "Redaktör",
  handläggare: "Handläggare",
  läsare: "Läsare",
};

export const ROLE_DESCRIPTIONS = {
  superadmin: "Full kontroll: hanterar alla användare, nycklar och inställningar.",
  admin: "Hanterar agenter, integrationer/nycklar och team (ej Super Admin).",
  redaktör: "Skapar och redigerar agenter och kunskapsbas. Ingen åtkomst till nycklar.",
  handläggare: "Arbetar i Co-pilot och konversationer. Kan inte redigera agenter.",
  läsare: "Endast läsbehörighet till dashboards och analys.",
};

const PERMISSIONS = {
  manage_users: ["superadmin", "admin"],
  manage_integrations: ["superadmin", "admin"],
  manage_compliance: ["superadmin", "admin"],
  edit_agents: ["superadmin", "admin", "redaktör"],
  run_costly: ["superadmin", "admin", "redaktör", "handläggare"],
  use_copilot: ["superadmin", "admin", "redaktör", "handläggare"],
  view: ROLES,
};

const DEMO_BLOCKED = new Set(["manage_integrations", "manage_users", "run_costly", "manage_compliance"]);

export function can(user, perm) {
  if (!user || typeof user !== "object") return false;
  if (user.status === "pending") return false;
  if (user.is_demo && DEMO_BLOCKED.has(perm)) return false;
  return (PERMISSIONS[perm] || []).includes(user.role);
}
